module.exports = __webpack_public_path__ + "img/chauffe-marcel_04_icone.d7a92a46.svg";